import { render, staticRenderFns } from "./PictureView.vue?vue&type=template&id=c42e08e0&scoped=true"
import script from "./PictureView.vue?vue&type=script&lang=js"
export * from "./PictureView.vue?vue&type=script&lang=js"
import style0 from "./PictureView.vue?vue&type=style&index=0&id=c42e08e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42e08e0",
  null
  
)

export default component.exports